import { gsap } from '../global/gsap';

const initSpeakerCards = (cards) => {
    const body = document.querySelector('body');
    const overlay = document.querySelector('.js-speaker-overlay');
    let overlayContainer = null;
    let loader = null;
    if(overlay) {
        overlayContainer = overlay.querySelector('.js-speaker-overlay-target');
        loader = overlay.querySelector('.js-loader');
    }

    if(overlay) {
        const fetchContent = (url) => {
            overlay.classList.add('is-active');
            body.classList.add('stop-scrolling');
            
            fetch(url).then((response) => response.text()).then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const content = doc.querySelector('.js-speaker-content');

                if (content) {
                    overlayContainer.appendChild(content);
                    return doc;
                }

                return null;

            }).then((doc) => {

                const closeButtons = overlay.querySelectorAll('.js-speaker-overlay-close');

                if (closeButtons && closeButtons.length > 0) {
                    closeButtons.forEach(button => {
                        button.addEventListener('click', () => {
                            closeOverlay();
                        })
                    })
                };



                gsap.set(overlayContainer, {
                    opacity: 0,
                    yPercent: 20
                })

                
                gsap.to(loader, {
                    opacity: 0,
                    duration: .25,
                    onComplete: () => {
                        gsap.to(overlayContainer, {
                            opacity: 1,
                            yPercent: 0
                        })
                    }
                })
            }).catch(err => {
                closeOverlay();
            })
        }

        const closeOverlay = () => {
            body.classList.remove('stop-scrolling');
            overlay.classList.remove('is-active');
            overlayContainer.innerHTML = '';
            gsap.set(loader, {
                opacity: 1
            });
        }

        overlay.addEventListener('click', (e) => {
            if(e.target == overlayContainer) {
                closeOverlay();
            }
        })


        cards.forEach(card => {
            const fetchUrl = card.dataset.url;

            card.addEventListener('click', () => {
                fetchContent(fetchUrl);
            })
        })
    }

};

export { initSpeakerCards as default };
